<template>
    <div class="bg-white shadow sm:rounded-lg">
        <div class="px-4 py-5 sm:p-6">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
                <slot name="header"></slot>
            </h3>
            <div class="mt-2 text-sm leading-5 text-gray-500">
                <slot></slot>
            </div>
            <div class="mt-5 text-right">
                <slot name="action"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Action"
    }
</script>

<style scoped>

</style>
